import { $, $$ } from "@zimpa/dom";

const CONTAINER_SELECTOR = '.js-yt-video-container';
const VIDEO_SELECTOR = '.js-yt-video';
const VIDEO_TRIGGER_SELECTOR = '.js-yt-video-trigger';

const YTPlayer = require('yt-player')

const ACTIVE_CLASS = 'active';

const CLICK_EVENT_TYPE = 'click';


class YoutubeVideo {

    public constructor(container: HTMLDivElement) {

        const videoEl = $<HTMLDivElement>(VIDEO_SELECTOR,container);
        const videoTriggerEl = $<HTMLDivElement>(VIDEO_TRIGGER_SELECTOR,container);

        if(videoEl===undefined || videoTriggerEl===undefined){
            return;
        }

        const videoId = <string>videoEl.getAttribute('data-videoid');

        if(videoId===undefined){
            return;
        }

        const player = new YTPlayer(videoEl);

        player.load(videoId);
        player.setVolume(100);

        videoTriggerEl.addEventListener(CLICK_EVENT_TYPE,() => {
            container.classList.add(ACTIVE_CLASS);
            player.play();
        })

    }
}



export function ytVideo(): void {
    $$(CONTAINER_SELECTOR).map(
        (element: HTMLDivElement): YoutubeVideo => {
        return new YoutubeVideo(element);
    },
);
}
